import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Users, ChevronDown } from "lucide-react";
import { toast } from "sonner";

const FIELDS = [
  ["cognome", "Cognome"], ["nome", "Nome"], ["codice_fiscale", "Codice fiscale"], ["data_nascita", "Data di nascita", "date"],
  ["comune_nascita", "Comune di nascita"], ["provincia_nascita", "Prov. nascita"], ["email", "Email", "email"], ["cellulare", "Cellulare"],
];
const EMPTY = Object.fromEntries(FIELDS.map(([k]) => [k, ""]));

export const CoobbligatoCard = ({ practice, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [open, setOpen] = useState(false);
  const saved = practice.coobbligato || {};
  const savedName = `${saved.cognome || ""} ${saved.nome || ""}`.trim();
  useEffect(() => { setForm({ ...EMPTY, ...(practice.coobbligato || {}) }); }, [practice.coobbligato]);
  const dirty = FIELDS.some(([k]) => (form[k] || "") !== ((practice.coobbligato || {})[k] || ""));

  const save = async () => {
    setSaving(true);
    try {
      const body = { ...form, codice_fiscale: form.codice_fiscale.trim().toUpperCase(), provincia_nascita: form.provincia_nascita.trim().toUpperCase() };
      const { data } = await api.put(`/practices/${practice.id}`, { coobbligato: body });
      onSaved(data); toast.success("Dati coobbligato salvati");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <Card className="p-5 space-y-3" data-testid="coobbligato-card">
      <button type="button" className="w-full flex items-center justify-between gap-2 text-left" onClick={() => setOpen(!open)} data-testid="coob-toggle-btn">
        <h2 className="font-heading font-semibold flex items-center gap-2"><Users className="h-4 w-4 text-primary" /> Coobbligato <span className="text-xs font-normal text-muted-foreground">{savedName || "(facoltativo)"}</span></h2>
        <span className="flex items-center gap-1 text-xs text-primary">{open ? "Nascondi" : savedName ? "Mostra" : "Aggiungi"}<ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && (<>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, label, type]) => (
          <div key={k} className="space-y-1 min-w-0">
            <Label className="text-xs">{label}</Label>
            <Input type={type || "text"} className="min-w-0 w-full" value={form[k]} data-testid={`coob-${k}-input`} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">Usati per compilare i modelli documento e per la firma a distanza del coobbligato.</p>
      <Button className="w-full" data-testid="coob-save-btn" disabled={!dirty || saving} onClick={save}>Salva coobbligato</Button>
      </>)}
    </Card>
  );
};
